// Table Selector Component
import { Table as TableIcon } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@loader/ui';

import { useTablesListQuery } from '@/features/tables/hooks/useTableQueries';

interface TableSelectorProps {
  selectedTable: string;
  onTableChange: (value: string) => void;
}

export function TableSelector({
  selectedTable,
  onTableChange,
}: TableSelectorProps) {
  const { data: tables = [], isLoading: loading } = useTablesListQuery({
    status: 'active',
  });

  const selectedTableObj = tables.find((d) => d.id === selectedTable);

  return (
    <div className="w-full">
      <Select value={selectedTable} onValueChange={onTableChange}>
        <SelectTrigger className="w-full !w-full">
          {selectedTableObj ? (
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <TableIcon className="h-4 w-4 shrink-0" />
              <span className="truncate">{selectedTableObj.name}</span>
            </div>
          ) : (
            <SelectValue
              placeholder={
                loading ? 'Loading tables...' : 'Select a table...'
              }
            />
          )}
        </SelectTrigger>
        <SelectContent>
          {tables.map((table) => (
            <SelectItem key={table.id} value={table.id} textValue={table.name}>
              <div className="flex items-center gap-2">
                <TableIcon className="h-4 w-4" />
                <div>
                  <div className="font-medium">{table.name}</div>
                  <div className="text-muted-foreground text-xs">
                    {table.description}
                  </div>
                </div>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
